import { useCrhClickCountingContext } from "../../../helpers/CrhClickCountingContext";
import { TagsList } from "../TagsList/TagsList";
import { CosmosText } from "@cosmos/web-react";
import classNames from "classnames/bind";
import Link from "next/link";
import styles from "./Question.module.css";

const cx = classNames.bind(styles);

export function Question({
  question,
  tags = [],
  onClick,
  href,
}: {
  question: string;
  tags?: string[];
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  href: string;
}) {
  const { trackClick } = useCrhClickCountingContext();
  return (
    <div className={cx("container")}>
      <h2 className={cx("question")}>
        <Link
          href={href}
          className={cx("link")}
          type="button"
          onClick={(event) => {
            trackClick();
            onClick(event);
          }}
        >
          <CosmosText
            tag="span"
            size="small"
            weight="regular"
            appearance="dark"
          >
            {question}
          </CosmosText>
        </Link>
      </h2>
      <div className={cx("tags")}>
        <TagsList tags={tags} />
      </div>
    </div>
  );
}
